<div *ngIf="loading"
     class="container-loading-content is-flex is-justify-content-center is-align-items-center">
    <div class="loading"></div>
</div>
<div *ngIf="!loading">
    <p *ngIf="articles.length == 0" class="txt ">Für Ihren Account sind noch keine Favoriten
        hinterlegt.</p>
    <div *ngIf="articles.length != 0">
        <div>
            <div class="container-article-sort has-text-right is-flex-desktop is-align-items-center mb-4">
                <div class="is-flex-grow-1">
                    <p class="mr-2 is-size-6 has-text-grey">Sortieren nach:</p>
                </div>

                <div  class="select">
                    <select (change)="setSort($event)" aria-label="Sortieren nach">
                        <option value="customerFavoritePosition" [selected]="sort=='customerFavoritePosition'">Meine Sortierung</option>
                        <option value="nameASC" [selected]="sort=='nameASC'">Name aufsteigend</option>
                        <option value="nameDESC" [selected]="sort=='nameDESC'">Name absteigend</option>
                    </select>
                </div>
            </div>
            <div class="my-3">
                <iw-shop-core-paginator [start]="start" [limit]="limit" [length]="articles.length" (onChange)="changePage($event)"></iw-shop-core-paginator>
            </div>
            <div cdkDropList
                 (cdkDropListDropped)="drop($event)" class="container-articles-list">
                <div cdkDrag  *ngFor="let a of getArticles(); let i = index; " class="mb-2">
                    <p  *ngIf="articles.length > 0 && i > 0 && sort != 'customerFavoritePosition' && a.groups[0].groupName !== getArticles()[i-1].groups[0].groupName"
                        class="is-size-4 mt-4">{{a.groups[0].groupName}}</p>
                    <p  *ngIf="i == 0 && sort != 'customerFavoritePosition'"
                        class="is-size-4">{{a.groups[0].groupName}}</p>
                    <fa-icon [icon]="faBars" class="handle-icon" cdkDragHandle [ngClass]="(sort != 'customerFavoritePosition' ) ? 'is-hidden': ''"></fa-icon> <!-- Example drag icon -->
                    <iw-shop-article-template-list [article]="a"></iw-shop-article-template-list>
                </div>
            </div>
            <div class="my-3">
                <iw-shop-core-paginator [start]="start" [limit]="limit" [length]="articles.length" (onChange)="changePage($event)"></iw-shop-core-paginator>
            </div>
        </div>

    </div>
</div>
